import { map } from 'rxjs';
import { TuiInputModule, TuiTagModule } from '@taiga-ui/kit';
import { TuiTextfieldControllerModule } from '@taiga-ui/core';
import { Store } from '@ngrx/store';
import { ISS_RESET_PASSWORD, WO_USER_PERMISSIONS, WO_USER_ROLES } from '@iss/libs/auth';
import { FormsModule } from '@angular/forms';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';

import { AccountTitleComponent } from './account-title';

import { environment } from '@wo-environments';
import { authFeature } from '@iss/wo-common/ngrx';
import { PageComponent } from '@iss/core/portal';
import { IconComponent } from '@iss/core/icon';
import { FormFieldComponent, LabelDirective } from '@iss/core/forms';

@Component({
  templateUrl: './account.component.html',
  styleUrls: [ './account.component.scss' ],
  standalone: true,
  imports: [
    AccountTitleComponent,
    AsyncPipe,
    FormFieldComponent,
    FormsModule,
    IconComponent,
    LabelDirective,
    NgForOf,
    NgIf,
    TuiInputModule,
    TuiTagModule,
    TuiTextfieldControllerModule,
  ],
})
export class AccountComponent extends PageComponent {
  private readonly store = inject(Store);
  private readonly resetPassword = inject(ISS_RESET_PASSWORD, { optional: true });
  public readonly resetPasswordLink = this.resetPassword ? this.resetPassword() : undefined;
  public readonly production = environment.production;
  public readonly username$ = this.store.select(authFeature.selectUsername);
  public readonly email$ = this.store.select(authFeature.selectUserEmail);
  public readonly roles$ = inject(WO_USER_ROLES).pipe(map(roles => [ ...roles.values() ].sort()));
  public readonly permissions$ = inject(WO_USER_PERMISSIONS).pipe(map(permissions => [ ...permissions.values() ].sort()));

  protected readonly breadcrumbs = [ { title: 'page.account' } ];

  @ViewChild('title', { read: TemplateRef }) public override title?: TemplateRef<unknown>;
}
